<app-filter-view [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
    [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
    [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
    [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
    [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
    [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
    [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
    [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
    [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName" [selectedItemsIdGlobal]="selectedItemsIdGlobal"
    [dropdownListOrderStatus]="dropdownListOrderStatus" [dropdownListLead]="dropdownListLead"
    [selectedItemsOrderStatus]="selectedItemsOrderStatus" [selectedItemsLead]="selectedItemsLead"
    [viewOrderStatus]="viewOrderStatus" [viewMonth]="viewMonth" [overviewOrderdDetailReportSpan]="false"
    [slaKpiSpan]="false" [completedDetailSpan]="true" (sendFilterEvent)="loadReport($event)"
    (updateFilterEvent)="updateFilterEvent($event)">
</app-filter-view>

<div class="d-flex justify-content-start mt-4" *ngIf="viexExportPdf()">
    <button class="btn btn-primary btn-lg active btn-sm reset-style" (click)="initializeTendine()">RESET FILTERS</button>

    <button class="btn btn-primary btn-lg active btn-sm logout-style" (click)="htmltoPDF()">EXPORT PDF</button>
</div>


<div class="chart" #reportCompletedDetail style="margin-top:4%;">
    
        <canvas baseChart  [datasets]="chart_Data" [labels]="chart_Labels"
            [options]="chart_Options" [plugins]="chart_Plugins" [legend]="chart_Legend" [chartType]="chart_Type"
            [colors]="colors">

        </canvas>
    
</div>